import { action } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useControllers } from '../../hooks/controller.hooks';
import { useProps, useStore } from '../../utils/mobx.utils';
import { first } from '../../utils/ramdaEquivalents.utils';
import { countriesByDialCodes } from '../../utils/tel.utils';
import BaseIcon from '../BaseIcon/BaseIcon';
import OverlayCloseButton from '../OverlayCloseButton/OverlayCloseButton';
import SearchBar from '../SearchBar/SearchBar';
import './CountryDialCodeSelector.scss';
var CountryDialCodeSelector = function (props) {
    var UI = useControllers().UI;
    var p = useProps(props);
    var s = useStore(function () { return ({
        get dialCode() {
            return p.form[p.field];
        },
        get countryDef() {
            return s.dialCode ? countriesByDialCodes.find(function (c) { return c.dialCode === s.dialCode; }) : null;
        },
        query: '',
        get list() {
            if (s.query)
                return countriesByDialCodes.filter(function (c) { return c.searchString.includes(s.query); });
            return countriesByDialCodes;
        },
        selectFirst: function () {
            var _a;
            if (p.disabled)
                return;
            var firstResult = first(s.list);
            var dialCode = firstResult === null || firstResult === void 0 ? void 0 : firstResult.dialCode;
            dialCode && ((_a = p.onUserSelection) === null || _a === void 0 ? void 0 : _a.call(p, dialCode));
            UI.OVERLAY.dismiss();
        }
    }); });
    var selectCountry = function (c) { return action(function () {
        var _a;
        if (p.disabled)
            return;
        p.form[p.field] = c.dialCode;
        (_a = props.onUserSelection) === null || _a === void 0 ? void 0 : _a.call(props, c.dialCode);
        UI.OVERLAY.dismiss('CountryPicker');
    }); };
    var pickACountry = function () {
        if (p.disabled)
            return;
        UI.OVERLAY.present({
            name: "CountryPicker",
            component: React.createElement(Observer, { children: function () { return React.createElement("div", { className: "CountryPopupSelectorDialogContent" },
                    React.createElement("header", null,
                        React.createElement("div", { className: "CountryPopupSelectorDialogContentHeaderInner" },
                            React.createElement(SearchBar, { form: s, field: "query", placeholder: "Look for a country/region\u2026", autoFocus: true, onEnter: p.disabled ? undefined : s.selectFirst })),
                        React.createElement(OverlayCloseButton, null)),
                    React.createElement("ul", { className: "CountryPopupSelectorDialogCountryList" }, s.list.map(function (c, i) { return React.createElement("li", { key: c.dialCode + '_' + i }, c.countries.map(function (country) { return React.createElement("button", { onClick: selectCountry(c), className: "CountryPopupSelectorDialogCountryButton", key: country.name },
                        React.createElement("span", null, country.flag),
                        React.createElement("strong", null,
                            "+",
                            c.dialCode),
                        React.createElement("span", null, country.name)); })); }))); } }),
            appearance: 'card',
        });
    };
    useHotkeys('escape', function () {
        UI.OVERLAY.dismiss();
    });
    return React.createElement(Observer, { children: function () {
            var _a, _b, _c, _d, _e, _f;
            return React.createElement(React.Fragment, null,
                React.createElement("button", { className: "CountryDialCodeSelector", title: "Select Country", name: "country-selector", "data-cy": p.dataCy, onClick: p.disabled ? undefined : pickACountry, ref: p.innerRef, disabled: p.disabled },
                    !p.doNotShowFlag && React.createElement("span", { className: "CountryPopupSelectorFlag" }, ((_a = s.countryDef) === null || _a === void 0 ? void 0 : _a.countries.length) === 1 && ((_c = (_b = s.countryDef) === null || _b === void 0 ? void 0 : _b.countries[0]) === null || _c === void 0 ? void 0 : _c.flag)),
                    p.showDialCode && ((_d = s.countryDef) === null || _d === void 0 ? void 0 : _d.dialCode) && React.createElement("span", { className: "CountryPopupSelectorDialCode" },
                        "+",
                        s.countryDef.dialCode),
                    p.showCountryName && React.createElement("span", { className: "CountryPopupSelectorCountryName" }, (_f = (_e = s.countryDef) === null || _e === void 0 ? void 0 : _e.countries[0]) === null || _f === void 0 ? void 0 : _f.name),
                    React.createElement(BaseIcon, { icon: "dropdown-arrow", variant: "filled", size: "1.2rem" })));
        } });
};
export default CountryDialCodeSelector;
